export const colorGradients = {
  gray: {
    "100": "#F7FAFC",
    "200": "#EDF2F7",
    "300": "#E2E8F0",
    "400": "#CBD5E0",
    "500": "#A0AEC0",
    "600": "#718096",
    "700": "#4A5568",
    "800": "#2D3748",
    "900": "#1A202C",
  },
  green: {
    "100": "#F0FFF4",
    "200": "#C6F6D5",
    "300": "#9AE6B4",
    "400": "#68D391",
    "500": "#48BB78",
    "600": "#38A169",
    "700": "#2F855A",
    "800": "#276749",
    "900": "#22543D",
  },
  blue: {
    "100": "#EBF8FF",
    "200": "#BEE3F8",
    "300": "#90CDF4",
    "400": "#63B3ED",
    "500": "#4299E1",
    "600": "#3182CE",
    "700": "#2B6CB0",
    "800": "#2C5282",
    "900": "#2A4365",
  },
}

interface ColorGradient {
  "100": string,
  "200": string,
  "300": string,
  "400": string,
  "500": string,
  "600": string,
  "700": string,
  "800": string,
  "900": string,
}

export interface ThemeColors {
  primary: string

  // background colors
  bgMain: string
  bgSecond: string
  bgAlt: string

  // button colors
  buttonAlt: string

  // text colors
  textMain: string
  textSecond: string
  textAlt: string
  placeholder: string

  // state colors
  success: string
  danger: string
  warning: string
  info: string
  disabled: string

  // border colors
  borderColor: string
  shadowColor: string

  // transactions
  bgTransaction: string

  // navigation
  statusBarStyle: 'light' | 'dark'
  tabBackground: string
  tabInactiveText: string
  tabActiveText: string
  headerBackground: string
  headerText: string
  footerBackground: string

  // loading animation colors
  loadingAnimation: {
    color1: string
    color2: string
    color3: string
  }
  skeletonLoader: string

  // scrollbar colors
  scrollbarThumb: string

  // extra palette colors
  second: string
  dark: string
  darkAccent: string
  lightAccent: string
  white: string
  gray: ColorGradient
  green: ColorGradient
  blue: ColorGradient
}

export interface Theme {
  name: string
  dark: boolean
  colors: ThemeColors
}
